export function getCategorias(data: any): Record<string, any> {
  const source = (data || {}) as Record<string, any>;
  const filteredSource: Record<string, any> = {};

  Object.entries(source).forEach(([categoriaKey, subcategorias]) => {
    if (categoriaKey === 'Siniestro') return;
    if (!Array.isArray(subcategorias)) return;

    const filteredSubcategorias = subcategorias
      .map((subcategoriaObj) => {
        if (!subcategoriaObj || typeof subcategoriaObj !== 'object') {
          return null;
        }

        const entries = Object.entries(subcategoriaObj);
        if (entries.length === 0) return null;

        const [subKey, subData] = entries[0] as [string, any];
        const isActive = (subData?.active ?? true) === true;
        if (!isActive) return null;

        return { [subKey]: subData };
      })
      .filter((sub): sub is Record<string, any> => !!sub);

    if (filteredSubcategorias.length > 0) {
      filteredSource[categoriaKey] = filteredSubcategorias;
    }
  });

  return filteredSource;
}

export function getCategoriasSiniestro(data: any): Record<string, any> {
  const source = (data || []) as Array<any>;
  const filteredSource: Record<string, any> = { Siniestro: [] };

  if (!Array.isArray(source)) {
    return filteredSource;
  }

  const filteredSubcategorias = source
    .map((subcategoriaObj) => {
      if (!subcategoriaObj || typeof subcategoriaObj !== 'object') {
        return null;
      }

      const entries = Object.entries(subcategoriaObj);
      if (entries.length === 0) return null;

      const [subKey, subData] = entries[0] as [string, any];

      const isActive = (subData?.active ?? true) === true;
      if (!isActive) return null;

      return { [subKey]: subData };
    })
    .filter((sub): sub is Record<string, any> => !!sub);

  if (filteredSubcategorias.length > 0) {
    filteredSource['Siniestro'] = filteredSubcategorias;
  }

  return filteredSource;
}
